import { Video } from './video.model';

export class Videos {
  _id?: string;
  name: string = '';
  textColor: 'light' | 'dark' = 'light';
  background: string = '';
  backgroundMobile: string = '';
  backgroundVideo: string = '';
  backgroundFixed: boolean = false;
  videos: Array<Video> = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/videos.model.ts